<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
            title="جزئیات پیام"
        >
          <b-form @submit.prevent>
            <b-row>
              <b-col
                class="mt-2"
                md="8"
                offset-md="2"
              >
                <b-row>
                  <b-col class="col-md-12 mb-2">
                    <fm-file-select v-model="form.Image" label="عکس نوتیف" :entity="13" />
                  </b-col>
                  <b-col class="col-md-4">
                    <b-form-group
                        label="نوع"
                        label-for="notificationVia"
                        class="d-inline-block full-width"
                    >
                      <v-select
                          id="notificationVia"
                          v-model="form.Type"
                          dir="rtl"
                          :reduce="x => x.value"
                          label="text"
                          input-id="notificationGroup"
                          :clearable="false"
                          :options="enums('sendVia').filter(option => option.value !== null)"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col class="col-md-4">
                    <b-form-group
                      label="زمان ارسال"
                      label-for="SendTime"
                    >
                      <date-picker
                        v-model="form.SendTime"
                        placeholder=""
                        type="datetime"
                        format="YYYY-MM-DD HH:mm"
                        display-format="jYYYY-jMM-jDD HH:mm"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                        label="تخفیف"
                        label-for="CouponId"
                    >
                      <z-coupon
                          v-model="form.CouponId"
                          :clearable="true"
                          :multiple="false"
                          :isDynamic="true"
                      />
                    </b-form-group>
                  </b-col>

                <b-col md="12">
                  <b-form-group
                      label="شناسه کاربر"
                      label-for="UserIds"
                  >
                    <b-form-tags
                        v-model="UserIds"
                        name="UserIds"
                        input-id="UserIds"
                        input-type="number"
                        duplicate-tag-text="این شناسه تکراری است"
                        placeholder=""
                        :number="true"
                        add-button-text="اضافه"
                        add-button-variant="outline-primary"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="12">
                  <b-form-group
                      label="سگمنت"
                      label-for="SegmentIds"
                  >
                    <selectSegmentCustom
                        v-model="SegmentIds"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group
                      label="عنوان"
                      label-for="Title"
                  >
                    <b-form-input
                        id="Title"
                        v-model="form.Title"
                        autocomplete="off"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group
                      label="نوع کلیک"
                      label-for="Action"
                  >
                    <z-action-notification
                        v-model="action"
                        :clearable="true"
                        :multiple="false"
                        @item="updateAction"
                    />
                    <span
                        v-if="submitted && !validation.actionType"
                        class="text-danger font-small-2"
                    >
                      نوع کلیک الزامی است
                    </span>
                  </b-form-group>
                </b-col>

                  <b-col md="12">
                    <b-form-group
                        label="لینک"
                        label-for="Url"
                    >
                      <b-input-group
                          id="url"
                          :prepend="selectedAction.BaseURL"
                          class="input-group-url"
                      >
                        <b-form-input v-model="form.ActionValue" autocomplete="off" />
                      </b-input-group>
                      <span
                          v-if="submitted && !validation.actionValue"
                          class="text-danger font-small-2"
                      >
                        لینک الزامی است
                      </span>
                    </b-form-group>
                  </b-col>

                <b-col md="12">
                  <b-form-group
                      label="متن"
                      label-for="Description"
                  >
                    <b-form-textarea
                        id="Description"
                        v-model="form.Description"
                        name="Description"
                        rows="3"
                    />
                  </b-form-group>
                </b-col>

                <b-row v-if="form.Type === 1">
                  <b-col md="auto">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      :disabled="form.Description.length === 0"
                      variant="outline-info"
                      size="sm"
                      pill
                      @click="calculatePrice"
                    >
                      <b-spinner
                        v-show="calculate.loading"
                        small
                        class="btn-loading"
                      />
                      <span>محاسبه</span>
                    </b-button>
                  </b-col>
                  <template v-if="calculate.isDone">
                    <b-col
                      align-self="end"
                      md="auto"
                    >
                      <span class="mr-1 ticketTitleKsy">  صفحه </span>
                      <b-badge
                        v-b-tooltip.hover
                        variant="light-info"
                      >
                        {{ calculate.details.PageCount }}
                      </b-badge>
                    </b-col>
                    <b-col
                      align-self="end"
                      md="auto"
                    >
                      <span class="mr-1 ticketTitleKsy"> تعداد  </span>
                      <b-badge
                        v-b-tooltip.hover
                        variant="light-info"
                      >
                        {{ calculate.details.SmsCount }}
                      </b-badge>
                    </b-col>
                    <b-col
                      align-self="end"
                      md="auto"
                    >
                      <span class="mr-1 ticketTitleKsy"> هزینه </span>
                      <b-badge
                        v-b-tooltip.hover
                        variant="light-info"
                      >
                        {{ calculate.details.FinalCost }}

                      </b-badge>
                    </b-col>
                  </template>
                </b-row>

                <b-col md="12" class="mt-2">
                  <h3>دکمه ها</h3>
                  <b-row>
                    <b-col v-for="(btn, index) in actionButtons" :key="index" class="col-md-12 border-bottom py-2">
                      <b-row>
                        <b-col class="col-md-11">
                          <b-row>
                            <b-col md="6">
                              <b-form-group
                                  label="عنوان دکمه"
                                  label-for="Title"
                              >
                                <b-form-input
                                    id="Title"
                                    v-model="btn.Label"
                                    autocomplete="off"
                                />
                                <span
                                    v-if="submitted && !btn.Label"
                                    class="text-danger font-small-2"
                                >
                                  عنوان دکمه الزامی است
                                </span>
                              </b-form-group>
                            </b-col>
                            <b-col md="6">
                              <b-form-group
                                  label="نوع کلیک"
                                  label-for="Action"
                              >
                                <z-action-notification
                                    v-model="btn.action"
                                    :key="index"
                                    :clearable="true"
                                    :multiple="false"
                                    @item="updateBtnAction($event, index)"
                                />
                                <span
                                    v-if="submitted && !btn.action"
                                    class="text-danger font-small-2"
                                >
                                  نوع کلیک الزامی است
                                </span>
                              </b-form-group>
                            </b-col>

                            <b-col md="12">
                              <b-form-group
                                  label="لینک"
                                  label-for="Url"
                              >
                                <b-input-group
                                    id="url"
                                    :prepend="btn.url"
                                    class="input-group-url"
                                >
                                  <b-form-input autocomplete="off" v-model="btn.appendUrl"
                                  />
                                </b-input-group>
                                <span
                                    v-if="submitted && !btn.appendUrl"
                                    class="text-danger font-small-2"
                                >
                                  لینک الزامی است
                                </span>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col class="col-md-1">
                          <b-button
                              size="sm"
                              variant="outline-danger"
                              class="mt-2 px-1"
                              @click="deleteActionBtn(index)"
                          >
                            <feather-icon icon="Trash2Icon" />
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col md="12" class="my-2">
                      <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          @click="addActionBtn"
                      >
                        افزودن دکمه
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col cols="12">
                  <b-form-group class="mt-1">
                    <b-form-checkbox
                        v-model="form.SaveInInbox"
                        value="true"
                        class="custom-control-success"
                    >
                      در صندوق پیام کاربر ذخیره شود.
                    </b-form-checkbox>

                  </b-form-group>
                </b-col>

                <b-col cols="12">
                  <b-form-group class="mt-1 mb-2">
                    <b-form-checkbox
                        v-model="form.IsDraft"
                        value="true"
                        class="custom-control-info"
                    >
                      به عنوان پیش نویس ذخیره شود.
                    </b-form-checkbox>

                  </b-form-group>
                </b-col>

                <b-col cols="12">
                  <hr>
                </b-col>

                <b-col class="mt-1 mb-2 text-center">
                  <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="submit"
                  >
                    ذخیره
                  </b-button>
                  <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                  >
                    بازگشت
                  </b-button>
                </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

import selectSegmentCustom from '@/tools/selectSegmentCustom.vue'
import ZCoupon from '@/tools/coupon.vue'
import ZActionNotification from "@/tools/actionNotification.vue"
import FmFileSelect from "@/views/menu/file-manager/components/fmFileSelect.vue"

export default {
  name: 'SendNotification',
  components: { FmFileSelect, selectSegmentCustom, ZCoupon, ZActionNotification },
  data() {
    return {
      loading: false,
      form: {
        Title: null,
        Uri: null,
        Type: 0,
        Description: '',
        SendTime: null,
        IsDraft: true,
        CouponId: null,
        SaveInInbox: true,
        Image: null,
        ActionValue: null,
        ActionKey: null
      },
      calculateInfo: {},
      CalculateLoading: true,
      calculate: {
        loading: false,
        isDone: false,
        details: {},
      },
      action: '',
      selectedAction: {},
      actionButtons: [],
      UserIds: [],
      SegmentIds: [],
      actionButton: {
        action: '',
        url: '',
        Key: '',
        Label: '',
        appendUrl: '',
      },
      submitted: false
    }
  },
  computed: {
    validation() {
      return {
        actionType: !!this.action && !!this.form.ActionKey,
        actionValue: !!this.form.ActionValue
      }
    },
    isValid() {
      let valid = true
      if (!this.action) valid = false
      Object.keys(this.validation).forEach(key => {
        if (!this.validation[key]) valid = false
      })
      this.actionButtons.forEach(btn => {
        if (!btn.Label) valid = false
        else if (!btn.Key) valid = false
        else if (!btn.appendUrl) valid = false
      })
      return valid
    }
  },
  created() {
    if (this.$route.params.messageId && this.$route.params.messageId !== ('new')) {
      this.showMessageDetail(this.$route.params.messageId)
    }
    if (this.$route.params.customSegmentId) {
      // connect server to get detail message
      this.SegmentIds = parseInt(this.$route.params.customSegmentId, 10)
    }
  },
  methods: {
    calculatePrice() {
      this.calculate.loading = true
      this.$http.post(this.$api.declarations.price, {
        Ids: this.SegmentIds,
        Description: this.form.Description,
      }).then(response => {
        this.calculate.details = response.data
        this.calculate.loading = false
        this.calculate.isDone = true
      }).finally(() => { this.calculate.loading = false })
    },
    submit() {
      this.submitted = true
      if (!this.isValid) return
      let data = {
        ...this.form,
        UserIds: this.UserIds,
        SegmentIds: this.SegmentIds,
        Id: this.$route.params.messageId || null,
        ActionButtons: this.actionButtons.map(item => {
          return {
            Key: item.Key,
            Label: item.Label,
            Value: item.appendUrl,
          }
        })
      }
      this.save(data)
    },
    save(data) {
      this.loading = true

      let url = this.$api.declarations.add
      if (this.form.Id){
        url = this.$api.declarations.update
      }

      this.$http.post(url, data).then(() => {
        this.loading = false
        this.back()
      }).finally(() => {
        this.loading = false
      })
    },
    showMessageDetail(declarationId) {
      this.loading = true
      this.$http.post(this.$api.declarations.get, { id: declarationId }).then(response => {
        this.form = response.data
        this.action = response.data.ActionId
        this.actionButtons = response.data.ActionButtons.map(item => {
          return {
            action: item.Id,
            url: '',
            Key: item.Key,
            Label: item.Label,
            appendUrl: item.Value,
          }
        })
        this.UserIds = response.data.UserIds
        this.SegmentIds = response.data.SegmentIds
        this.loading = false
      }).finally(() => {
        this.loading = false
      })
    },
    update() {
      this.loading = true
      this.$http.post(this.$api.declarations.update, this.form).then(() => {
        this.loading = false
      }).finally(() => {
        this.loading = false
      })
    },
    addActionBtn() {
      this.actionButtons.push({...this.actionButton})
    },
    deleteActionBtn(index) {
      this.$bvModal.msgBoxConfirm(
          'آیا مطمئن هستید که می خواهید این دکمه را حذف کنید؟', {
            title: 'حذف',
            size: 'sm',
            okVariant: 'danger',
            okTitle: 'حذف',
            cancelTitle: 'انصراف',
            cancelVariant: 'outline-secondary',
            hideHeaderClose: false,
            centered: true,
            modalClass: 'modal-danger modal-remove-confirm',
          },
      ).then(() => {
        this.actionButtons.splice(index, 1)
      })
    },
    updateAction(item) {
      this.form.ActionKey = item.key
      this.selectedAction = item
    },
    updateBtnAction(item, index) {
      this.actionButtons[index].Key = item.key
      this.actionButtons[index].url = item.BaseURL
    }
  },
}
</script>

<style scoped>

</style>
